var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var HeadingTitle = /** @class */ (function (_super) {
    __extends(HeadingTitle, _super);
    function HeadingTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadingTitle.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__heading-title", "data-uat": "div-ev-list-heading-title" },
            React.createElement("span", { className: "rj-ev-list__heading-title__content rj-ev-list__heading-title__name", "data-uat": "span-ev-list-heading-title-name" },
                this.props.name,
                React.createElement("span", { className: "rj-ev-list__heading-title__content rj-ev-list__heading-title__count", "data-uat": "span-ev-list-heading-title-count" }, this.props.eventsCount))));
    };
    return HeadingTitle;
}(React.PureComponent));
export { HeadingTitle };
//# sourceMappingURL=HeadingTitle.js.map